// @flow strict

import * as React from 'react';

type PropTypes = {|
  id: '',
  linkText: '',
|};

export const JumpLinkAnchorBase = (props: { ...PropTypes }) => {
  return (
    <>
      <a
        href="/"
        className="devotion-jump-link-anchor"
        data-link-text={props.linkText}
        id={props.id}
      >
        {}
      </a>
    </>
  );
};

const JumpLinkAnchor = (props: PropTypes) => <JumpLinkAnchorBase {...props} />;

export default JumpLinkAnchor;
